<span *ngIf="versionLabel as version" class="sm-app-version__wrapper">
  <span
    class="sm-app-version"
    tabindex="0"
    [attr.aria-label]="versionTooltip"
    [smPlainTextTooltip]="versionTooltip">
    {{ version }}
  </span>
</span>
